/* src/app/modules/portal/components/at-neocor-applications/at-neocor-applications.component.scss */
:host {
  display: flex;
  flex-direction: row;
  gap: 16px;
}
:host .content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  gap: 16px;
}
:host .content .text-content {
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 8px;
}
[screen-phone] :host {
  flex-direction: column;
}
/*# sourceMappingURL=at-neocor-applications.component.css.map */
